if (window.location.pathname === "/inyeccion/periodo") {

    const contGrafico = document.querySelector(".contGraficos");
    const contCanva = contGrafico.querySelector("#graficoProduccionSemanal");
    const params = new URLSearchParams(window.location.search);
    const mes = params.get("mes");
    const año = params.get("año");

    let graficoProduccionSemanal = null;

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        redirect: "follow",
    };

    window.actGraficoProduccionSemanal = (mes, año) => {

        const url = `/api/graficos/inyeccion/produccion-semanal?mes=${mes}&año=${año}`;

        fetch(url, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`Error HTTP: ${response.status}`);
                }

                return response.json();
            })
            .then((result) => {
                const data = result.result;
                const labels = data.map(item => item.semana);
                const cantidades = data.map(item => item.totalUndBueno);

                if (graficoProduccionSemanal) {
                    graficoProduccionSemanal.destroy();
                }

                contCanva.classList.remove('skeletonGrafico');

                graficoProduccionSemanal = new Chart(contCanva, {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [
                            {
                                type: 'bar',
                                data: cantidades,
                                backgroundColor: '#071f5f',
                                borderRadius: 3,
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            }
                        },
                        scales: {
                            y: {
                                position: 'left',
                                beginAtZero: true,
                                ticks: {
                                    callback: value => value / 1000 + 'k'
                                },
                                grid: {
                                    display: false
                                }
                            },
                            x: {
                                grid: {
                                    display: false
                                },
                                ticks: {
                                    display: true
                                }
                            }
                        }
                    }
                });
            })
            .catch((error) => {
                if (error.name === 'AbortError') return;
                console.error("Error gráfico producción semanal:", error);
            });
    };

    window.actGraficoProduccionSemanal(mes, año);

    setInterval(() => {
        window.actGraficoProduccionSemanal(mes, año);
    }, 120000);
}